export const blockIconsImageCameraAlt = (
	<span className='material-symbols-outlined'>camera_alt</span>
);
